import { apiClient } from '@/lib/axios';
import type { ReportStats, ApiResponse } from '@/types';

export interface ReportFilters {
  dateFrom?: string;
  dateTo?: string;
  city?: string;
  category?: string;
  bdId?: string;
  disease?: string;
  source?: string;
  status?: string;
  insurance?: boolean;
}

export const reportsApi = {
  getLeadsReport: async (filters: ReportFilters = {}): Promise<ReportStats> => {
    const { data } = await apiClient.get<ApiResponse<ReportStats>>('/reports/leads', { params: filters });
    return data.data!;
  },

  exportExcel: async (filters: ReportFilters = {}): Promise<Blob> => {
    const response = await apiClient.get('/reports/leads/export/excel', { params: filters, responseType: 'blob' });
    return response.data as Blob;
  },

  exportPDF: async (filters: ReportFilters = {}): Promise<Blob> => {
    const response = await apiClient.get('/reports/leads/export/pdf', { params: filters, responseType: 'blob' });
    return response.data as Blob;
  },

  exportCSV: async (filters: ReportFilters = {}): Promise<string> => {
    const response = await apiClient.get('/reports/leads/export/csv', { params: filters });
    return response.data as string;
  },
};
